export enum ETwoFactorAuthenticationSetupStep {
  ENTER_PHONE_NUMBER = 'ENTER_PHONE_NUMBER',
  ENTER_CODE = 'ENTER_CODE',
  SUCCESS = "SUCCESS"
}
